import React from 'react'
import { TextArea as UiKitTextArea } from '@elamajs/ui-kit'

import * as Styled from './TextArea.styled'

const TextArea = ({ ...props }) => {
  return <Styled.TextArea width="100%" as={UiKitTextArea} {...props} />
}

export default TextArea
